import { Component, OnInit, ViewChild } from "@angular/core";
import { AppService } from "src/_services/app.service";
import { Router } from "@angular/router";
import {
  MatDatepickerInputEvent,
  MatPaginator,
  PageEvent,
} from "@angular/material";
import * as moment from "moment";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-sr-market-void",
  templateUrl: "./sr-market-void.component.html",
  styleUrls: ["./sr-market-void.component.scss"],
})
export class SrMarketVoidComponent implements OnInit {
  public userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));
  ProviderId: string = "SportRadar";
  sportsList = [];
  showAlert: boolean = false;
  marketsList: any = null;
  sportId;
  sportName: string = "";
  start: any;
  end: any;
  sportSettings: any = {};
  selectedSport = new FormControl([]);
  selected: any = {
    startDate: null,
    endDate: null,
  };
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  length: any = 0;
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [moment(this.startOfDay), moment(this.endOfDay)],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  marketTableColumns = [
    "Time",
    "Event Name",
    "Market Id",
    "Market Name",
    "Status",
  ];
  constructor(private appService: AppService, private router: Router) {}

  ngOnInit() {
    this.getSportsByProvider(this.ProviderId);
    this.sportSettings = {
      singleSelection: true,
      idField: "SportId",
      textField: "SportName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.selected.startDate = moment().startOf("day");
    this.selected.endDate = moment().endOf("day");
  }

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.page = 1;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 7) {
        this.showAlert = true;
        this.selected.startDate = moment().startOf("day");
        this.selected.endDate = moment().endOf("day");
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);
      }
    }
  };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getVoidMarkets();
  }

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportForBetList(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsList = res.sports;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onFilterChange() {
    this.page = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.getVoidMarkets();
  }

  getVoidMarkets() {
    try {
      let filters = {
        sportId:
          this.selectedSport.value.length != 0
            ? this.selectedSport.value[0].SportId
            : "",
        startTime:
          this.selected.startDate !== null
            ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
        pageSize: this.orgPageSize,
        page: this.page,
      };
      this.appService.getVoidedMarkets(filters).subscribe((response) => {
        this.marketsList = response.markets;
        if (this.page == 1) {
          this.length = response.totalRecords;
        } else {
          this.paginator.length = this.length;
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  getExportExcel() {
    let filters = {
      sportId:
        this.selectedSport.value.length != 0
          ? this.selectedSport.value[0].SportId
          : "",
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
    };

    this.appService.getVoidedMarketsExcel(filters).subscribe((res) => {
      const contentType = "application/vnd.ms-excel";
      let blob1 = this.b64toBlob(res.file, contentType);
      let blobUrl1 = URL.createObjectURL(blob1);
      const link = document.createElement("a");
      link.href = blobUrl1;
      link.setAttribute("download", `voided_markets.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  }

  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }
}
